<template>
  <div :class="$style.app">
    <GameContainer
      v-on="$listeners"
      v-bind="$attrs"
      :items="itemsWithDefaultId"
      gameComponent="DragAndDropGame"
      hasTimer
    />
  </div>
</template>

<script>
import {computed} from '@vue/composition-api'

import GameContainer from '@/components/GameContainer'

import 'animate.css/animate.css'

export default {
  props: {
    items: {type: Array, required: true},
  },
  setup (props) {
    return {
      itemsWithDefaultId: computed(() => props.items.map(item => ({
        ...item,
        id: item.id || item.label,
      }))),
    }
  },
  components: {
    GameContainer,
  },
}
</script>

<style module lang="scss">
.app {
  :global {
    @import '~@/style/global';
    @include root-styles;
  }
}
</style>
